import loadable from '@loadable/component';
import {
  ROUTE_NARRATIVE_COMMUNITY_DETAIL,
  ROUTE_NARRATIVE,
  ROUTE_NARRATIVE_COMMUNITY_UPDATE_DETAIL,
} from '@/constants/routes';
import { AdPlan } from './AdPlan';

const ContentContainer = loadable(
  () => import('@/containers/ContentContainer')
);
const NotFound = loadable(() => import('@/pages/NotFound'));
const Oops = loadable(() => import('@/components/Oops'));
const Timeout = loadable(() => import('@/components/Timeout'));
const NarrativeNotFound = loadable(
  () => import('@/pages/Narrative/components/NarrativeNotFound'),
  {
    resolveComponent: (m) => m.NarrativeNotFound,
  }
);

type Props = {
  pageStatus: number;
  routeName: string;
};

export const ContentSimplyWallSt = ({ pageStatus, routeName }: Props) => {
  if (pageStatus === 404) {
    if (
      [
        ROUTE_NARRATIVE,
        ROUTE_NARRATIVE_COMMUNITY_DETAIL,
        ROUTE_NARRATIVE_COMMUNITY_UPDATE_DETAIL,
      ].includes(routeName)
    ) {
      return (
        <ContentContainer>
          <NarrativeNotFound />
        </ContentContainer>
      );
    }
    return <NotFound />;
  }
  if (pageStatus === 408) return <Timeout />;
  if (pageStatus >= 200 && pageStatus < 300)
    return (
      <>
        {/* TODO: revisit this if ad-supported-free-plan unleash flag is removed & experiment */}
        {/* is successful */}
        <AdPlan />
        <ContentContainer />
      </>
    );
  if (pageStatus >= 400 && pageStatus < 500) {
    // SEO: NOINDEX, FOLLOW for 4xx client errors to preserve link equity
    return <Oops allowFollow />;
  }
  if (pageStatus >= 500 && pageStatus < 600) {
    // SEO: Let 5xx server errors return without NOINDEX to avoid deindexing
    // Google handles brief 5xx errors gracefully, but NOINDEX triggers immediate deindexing
    return <Oops allowFollow allowCrawlers />;
  }

  return null;
};
